module.exports = __webpack_public_path__ + "assets/favicons/android-chrome-512x512.png";